const ITEMS = [
  "Payment screenshot + product screenshot",
  "No proof, no stamp",
  "Facts, not name-calling",
  "Search before you pay",
  "The room they wouldn't let you into",
];

export const Marquee = () => (
  <div
    data-testid="editorial-marquee"
    className="overflow-hidden border-y border-black/5 bg-white py-6 select-none"
    aria-hidden="true"
  >
    <div className="marquee-track items-center">
      {[...ITEMS, ...ITEMS].map((t, i) => (
        <span key={i} className="flex items-center shrink-0">
          <span
            className={`font-display text-2xl sm:text-3xl font-bold tracking-tight uppercase whitespace-nowrap px-10 ${
              i % 2 ? "outline-word" : "text-ink"
            }`}
          >
            {t}
          </span>
          <span className="w-2.5 h-2.5 rotate-45 bg-gold shrink-0" />
        </span>
      ))}
    </div>
  </div>
);
